import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Speakers from "@/components/site/Speakers";
import Agenda from "@/components/site/Agenda";
import WhoWillAttend from "@/components/site/WhoWillAttend";
import PartnersSponsors from "@/components/site/PartnersSponsors";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import BackToTop from "@/components/site/BackToTop";

export default function Home() {
  return (
    <div data-testid="page-home" className="min-h-screen bg-[#030712] text-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Speakers />
        <Agenda />
        <WhoWillAttend />
        <PartnersSponsors />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}
